const urlName = '/usercenter/v1/region/'

export default API => ({
    /**
     * 
     * @param {*} param0 
     */
    getRegionTree({ params, data }) { 
        return API({ url: `${urlName}getTree`, params, data });
    }
})